export const JUPITER_BASE_API_URL = 'https://quote-api.jup.ag'
export const JUPITER_API_URL = `${JUPITER_BASE_API_URL}/v6`
